<template>
  <div id='LoginWx'>
    <div class="wx-content">
      <div v-if="loading">
        <span style="font-size: 20px;color: #9f9f9f;">
          <i class="el-icon-warning" style="margin-right: 5px"></i>加载中...
        </span>
      </div>
      <div v-else-if="type === 'E'">
        <span style="font-size: 14px;color: #c01920;">
          <i class="el-icon-warning" style="margin-right: 5px"></i>{{msg}}
        </span>
      </div>
      <div v-else-if="type === 'U'">
        <span style="font-size: 14px;color: black;">
          <i class="el-icon-warning" style="margin-right: 5px"></i>{{msg}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../i18n'
import { mapMutations } from 'vuex'

export default {
  name: 'LoginWx',
  data () {
    return {
      loading: true,
      msg: '',
      type: ''
    }
  },
  created () {
    if (this.$route.query.typeWx) {
      this.updateWxOpenid()
    } else {
      this.loginWx()
    }
  },
  methods: {
    ...mapMutations('cacheTabs', ['setPage']),
    loginWx: async function () {
      this.setPage('HomePage')
      if (this.$route.query.code && this.$route.query.state) {
        const para = {
          code: this.$route.query.code,
          state: this.$route.query.state,
          language: this.$route.query.language
        }
        const { data: res } = await this.$http.post('/users/loginWx', para)
        if (res.meta.status !== 200) {
          this.loading = false
          this.msg = i18n.t('users.login.loginfailed') + res.meta.msg
          return
        }

        if (res.data.userStatus) {
          this.loading = false
          if (res.data.userStatus !== 'A') {
            this.msg = i18n.t('users.login.userstatusnotvalid')
            return
          }
          res.data.msgType = 'userMap'
          window.parent.postMessage(res.data, '*')
        } else {
          this.loading = false
          this.type = 'E'
          this.msg = '当前微信未绑定账号，请在个人信息中绑定'
        }
      } else {
        this.loading = false
        this.type = 'E'
        this.msg = '微信获取失败，请使用账号密码登录'
      }
    },
    updateWxOpenid: async function () {
      if (this.$route.query.code && this.$route.query.state) {
        const that = this
        const p = {
          userCode: this.$route.query.userCode,
          type: 'U',
          code: this.$route.query.code
        }
        const { data: res } = await that.$http.post('/users/updateWxOpenid', p)
        if (res.result) {
          this.loading = false
          this.msg = '绑定成功'
          this.type = 'U'
          res.msgType = 'userOpenid'
          window.parent.postMessage(res, '*')
        }
      } else {
        this.loading = false
        this.type = 'E'
        this.msg = '微信获取失败'
      }
    }
  }
}
</script>

<style lang="less" scoped>
#LoginWx {
  .wx-content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 300px;
  }
}
</style>
